<h1 mat-dialog-title>Save &amp; Share Filter</h1>
<div mat-dialog-content>
  <form class="standard-form">
    <mat-form-field>
      <mat-label>Name (required)</mat-label>
      <input
        matInput
        name="data.filter.name"
        [(ngModel)]="data.filter.name"
      /> </mat-form-field
    ><br />
    <ng-container *ngIf="!data.isNew">
      <mat-checkbox name="updateData" [(ngModel)]="data.updateData"
        >Update Filter Data?</mat-checkbox
      > </ng-container
    ><br />
  </form>
  <app-share-editor
    *ngIf="data.isOwner"
    allowReadOnly="true"
    allowModify="true"
    [(ngModel)]="data.shareState"
    [avaialbleSubscriptions]="data.userSubscriptions"
  ></app-share-editor>
</div>
<div mat-dialog-actions>
  <button
    mat-raised-button
    class="piButton"
    (click)="onConfirmClick()"
    cdkFocusInitial
  >
    Confirm
  </button>
  <button mat-raised-button class="piButton" (click)="onCancelClick()">
    Cancel
  </button>
</div>
